const PERIOD_LABELS = {
    last_week: 'ultima semana',
    last_month: 'ultimo mes',
    last_three_months: 'ultimos 3 meses',
    last_year: 'ultimo ano'
};

const SECTOR_LABELS = {
    Energy: 'Energia',
    Materials: 'Materiales',
    Utilities: 'Utilities',
    Financials: 'Finanzas',
    'Consumer Staples': 'Consumo basico',
    'Real Estate': 'Inmobiliario',
    'Comunication Services': 'Comunicacion',
    'Communication Services': 'Comunicacion',
    Industrials: 'Industrial',
    'Consumer Discretionary': 'Consumo discrecional',
    'Health Care': 'Salud',
    'Information Technology': 'Tecnologia'
};

const KNOWN_ENTRY_TYPES = new Set([
    'finder',
    'home',
    'ticker',
    'compatibility',
    'platinum',
    'last-ipos',
    'best-bullish-values',
    'best-sectors',
    'hot-values',
    'exchange',
    'sector',
    'favorites',
    'twin-souls',
    'informe',
    'description',
    'saved-search'
]);

const toStringValue = (value, fallback = '') => {
    if (value === null || value === undefined) {
        return fallback;
    }

    return String(value).trim();
};

const decodeLegacySegment = (value) => decodeURIComponent(toStringValue(value)).replaceAll('_and_', '&').replaceAll('+', ' ');

const resolvePeriodLabel = (value) => PERIOD_LABELS[toStringValue(value)] || toStringValue(value);
const resolveSectorLabel = (value) => SECTOR_LABELS[toStringValue(value)] || toStringValue(value);
const normalizeFinderEntryType = (value = '') => {
    const normalizedValue = toStringValue(value);

    if (!normalizedValue || normalizedValue === 'home' || normalizedValue === 'finder') {
        return 'finder';
    }

    return normalizedValue;
};

export function normalizeChartingEntryValue(value) {
    return decodeLegacySegment(value);
}

export function resolveChartingRouteEntry(route = {}) {
    const params = route?.params || {};
    const query = route?.query || {};
    const routeEntryType = toStringValue(params.entryType);
    const routeEntryValue = normalizeChartingEntryValue(params.entryValue);
    const fallbackSavedSearch = toStringValue(query.savedSearch);
    const fallbackDescription = toStringValue(query.description);
    const activeTickerHint = toStringValue(query.ticker || query.activeTicker || query.active_ticker).toUpperCase();

    let type = 'finder';
    let value = '';

    if (routeEntryType) {
        if (KNOWN_ENTRY_TYPES.has(routeEntryType)) {
            type = normalizeFinderEntryType(routeEntryType);
            value = routeEntryValue;
        } else {
            type = 'saved-search';
            value = normalizeChartingEntryValue(routeEntryType);
        }
    } else if (fallbackSavedSearch) {
        type = 'saved-search';
        value = fallbackSavedSearch;
    } else if (fallbackDescription) {
        type = 'description';
        value = fallbackDescription;
    }

    const title = (() => {
        switch (type) {
            case 'ticker':
                return value ? `Ticker ${value.toUpperCase()}` : 'Ticker';
            case 'compatibility':
                return 'Compatibilidad';
            case 'platinum':
                return 'Valores platinum';
            case 'last-ipos':
                return 'Ultimas IPOs';
            case 'best-bullish-values':
                return `Valores alcistas · ${resolvePeriodLabel(value)}`;
            case 'best-sectors':
                return `Mejores sectores · ${resolvePeriodLabel(value)}`;
            case 'hot-values':
                return `Mas comentados · ${resolvePeriodLabel(value)}`;
            case 'exchange':
                return value ? `Indice ${value}` : 'Indice';
            case 'sector':
                return value ? `Sector ${resolveSectorLabel(value)}` : 'Sector';
            case 'favorites':
                return value ? `Favoritos · ${value}` : 'Favoritos';
            case 'twin-souls':
                return 'Almas gemelas';
            case 'informe':
                return value ? `Informe · ${value}` : 'Tickers del informe';
            case 'description':
                return value ? `Rastreo · ${value}` : 'Rastreo por descripcion';
            case 'saved-search':
                return value ? `Busqueda guardada · ${value.replaceAll('Q1SPACEQ1', ' ')}` : 'Busqueda guardada';
            default:
                return 'Mercado';
        }
    })();

    const subtitle = (() => {
        switch (type) {
            case 'finder':
                return 'Exploracion general del mercado y listas base.';
            case 'ticker':
                return 'Vista directa de un ticker concreto.';
            case 'saved-search':
                return 'Consulta guardada resuelta sin mutar el finder activo.';
            case 'favorites':
                return 'Listado de tickers agrupados en una carpeta de favoritos.';
            default:
                return 'Entrada resuelta por el dominio charting.';
        }
    })();

    return {
        type,
        value,
        title,
        subtitle,
        activeTickerHint,
        isUserManagedSource: ['favorites', 'saved-search'].includes(type),
        signature: [type || 'finder', value || 'all'].join(':')
    };
}
